
import { FieldArrayWithId, useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import VirtualizedList from "../virtualized-list/VirtualizedList";
import NoData from "../no-data/NoData";
import ModifyPollingScheduleUtils, { PollingScheduleForm, PollingScheduleFormListItem } from "./ModifyPollingScheduleUtils";
import { TagPollingScheduleListItem } from "./TagPollingScheduleListItem";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { getObjectTypeName } from "../../common/utilities/GetObjectTypeName";
import { contains } from "../../common/utilities/Contains";
import { ITagPollingSchedule } from "../../services/properties-data-service/Models";

export type TagPollingScheduleListProps = {
    filterText: string;
    filteredSchedules: ITagPollingSchedule[],
    onChanged?: (item: PollingScheduleFormListItem, value: number) => void;
};

export default function TagPollingScheduleList({
    filterText,
    filteredSchedules,
    onChanged

}: TagPollingScheduleListProps) {

    const {t} = useTranslation();
    
    const {
        watch,
        control,
        //trigger,
        //getValues,
        //setValue
    } = useFormContext<PollingScheduleForm>();    

    const _fieldKey = (ndx: number) => `pollingSchedules.${ndx}`;

    const {
        fields,
        //insert,
        //append,
        //remove:
        //update,
        //replace
    } = useFieldArray({
        control: control,
        name: 'pollingSchedules',
        keyName: "fieldKey"
    });

    const [
        watchItems,
    ] = watch([
        'pollingSchedules',
    ]);

    const listItems = 
    fields.map((field, index) => {
        return {
            ...field,
            ...watchItems[index],
            fieldKey: _fieldKey(index)
        };
    });

    const count = ModifyPollingScheduleUtils.filterItems(listItems, filterText, filteredSchedules).length;


    function renderItem(_index: number, item: PollingScheduleFormListItem) {

        return (
            <TagPollingScheduleListItem
                item={item}
                //key={item.fieldKey} 
                // the key has to be affected by data that will cause the 
                // component to render and not be optimized out                
                key={`${item.fieldKey}.${item.scheduleID}`} 
                onChanged={onChanged}
            />
        );
    };

    function onFilterItem(item: FieldArrayWithId<PollingScheduleForm, 'pollingSchedules', 'fieldKey'>): boolean {

        let show = !!contains(item.tagName, filterText);

        if (show) {
            show = filteredSchedules.filter(o => o.selected).some(o => o.id === -1 || o.id === item.scheduleID);
        }

        return show;
    }

    return (
        
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            overflow: "hidden",
            overflowY: 'auto'
            }}>

            {count === 0 &&         
                <Box sx={{
                    padding: 1
                }}>
                    <NoData text={t('pollingFrequencyAdmin.nodata.noFilterMatch', {name: getObjectTypeName(eLynxObjectTypeEnum.Tag, true, true)})} />
                </Box>
            }
                                    
            <VirtualizedList
                items={listItems}
                renderItem={renderItem}
                filter={onFilterItem}
            />

        </Box>
    );
}

